module.exports = __webpack_public_path__ + "static/media/homicidal-jane.250c96a9.jpg";